import React from "react";
import { Table } from "reactstrap";
import { FormattedNumber } from "../../../FormattedNumber/FormattedNumber";
import translate from "../../../../utils/Translator";
import style from "../Grid.module.scss";

const RecCommissionsAccount = ({ account }) => (
  <div className={style.grid}>
    <Table responsive hover>
      <thead>
        <tr>
          <th>{translate("Account")}</th>
          <th className="text-right">Buying Power</th>
          <th className="text-right">Base for calculation</th>
          <th className="text-right">Commission</th>
          <th className="text-right">Tax</th>
          <th className="text-right">Total</th>
        </tr>
      </thead>
      <tbody>
        <tr key={account.ItemId}>
          <td>{account.AccountName}</td>
          <td className="text-right">
            <FormattedNumber value={account.RecurringCommissionBuyingPower} dataTypeDecimalName="currency" />
          </td>
          <td className="text-right">
            <FormattedNumber
              value={account.RecurringCommissionBaseCalculation}
              dataTypeDecimalName="currency"
            />
          </td>
          <td className="text-right">
            <FormattedNumber value={account.RecurringCommissionVolume} dataTypeDecimalName="currency" />
          </td>
          <td className="text-right">
            <FormattedNumber value={account.RecurringCommissionTax} dataTypeDecimalName="currency" />
          </td>
          <td className="text-right">
            <FormattedNumber value={account.RecurringCommissionTotal} dataTypeDecimalName="currency" />
          </td>
        </tr>
        {account.length === 0 && (
          <tr>
            <td colSpan={8} style={{ textAlign: "center" }}>
              No {translate("Account")}s
            </td>
          </tr>
        )}
      </tbody>
    </Table>
  </div>
);

export default RecCommissionsAccount;
